class CartDrawer extends HTMLElement {
    constructor() {
        super();

        // Ensure cart drawer starts closed
        this.classList.add('translate-x-full');
        if (document.getElementById('CartDrawer-Overlay')) {
            document.getElementById('CartDrawer-Overlay').classList.add('opacity-0', 'invisible');
        }

        document.addEventListener('click', (event) => {
            // Debug: log what element is being clicked
            if (event.target.closest('cart-drawer')) {
                console.log('Click detected on cart drawer element:', event.target);
                document.dispatchEvent(new CustomEvent('cart:updated'));
            }
            this.setHeaderCartIconAccessibility(event)
            this.initClose(event)
        })

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && !this.classList.contains('translate-x-full')) {
                this.close()
            }
        })
    }

    setHeaderCartIconAccessibility(event) {
        const cartLink = event.target.closest('#basketIcon');
        if (cartLink) {
            event.preventDefault()
            console.log('Cart icon clicked'); // Debug log
            document.dispatchEvent(new CustomEvent('cart:updated'));
            this.open()
        }
    }

    initClose(event) {
        const close = event.target.closest('#CartDrawer-Overlay') || event.target.closest('.js-cart-drawer-close')
        if (close) {
            event.preventDefault();
            event.stopPropagation();
            console.log('Close button clicked'); // Debug log
            this.close();
        }
    }

    open() {
        this.classList.remove('translate-x-full');
        this.style.pointerEvents = 'auto';
        document.getElementById('CartDrawer-Overlay').classList.remove('opacity-0', 'invisible');
        document.body.classList.add('!overflow-hidden');
        setTimeout(() => {
            this.querySelector('button').focus()
        }, 300)
    }

    close() {
        this.classList.add('translate-x-full');
        this.style.pointerEvents = 'none';
        document.getElementById('CartDrawer-Overlay').classList.add('opacity-0', 'invisible');
        document.body.classList.remove('!overflow-hidden');
    }

    renderContents(parsedState, doNotOpen = false) {
        this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section => {
            const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }));

        if (doNotOpen) {
            return
        }

        setTimeout(() => {
            // Remove existing event listeners to prevent duplicates
            const overlay = document.querySelector('#CartDrawer-Overlay');
            
            if (overlay) {
                overlay.removeEventListener('click', this.close.bind(this));
                overlay.addEventListener('click', this.close.bind(this));
            }
            
            // Setup close button using the new method
            this.setupCloseButton();
            
            this.open();
        });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '#CartDrawer'
            },
            {
                id: 'cart-icon-bubble'
            },
            {
                id: 'cart-price',
                section: 'cart-price'
            }
        ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }

    // Ensure cart drawer is closed on initialization
    connectedCallback() {
        this.forceClose();
        this.setupCloseButton();
        this.setupMutationObserver();
    }

    // Setup mutation observer to watch for content changes
    setupMutationObserver() {
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
        }
        
        this.mutationObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    // Check if close button was added/changed
                    const closeButton = this.querySelector('.js-cart-drawer-close');
                    if (closeButton) {
                        this.setupCloseButton();
                    }
                }
            });
        });
        
        this.mutationObserver.observe(this, {
            childList: true,
            subtree: true
        });
    }

    // Setup close button event listener
    setupCloseButton() {
        const closeButton = this.querySelector('.js-cart-drawer-close');
        if (closeButton) {
            // Remove any existing listeners
            closeButton.removeEventListener('click', this.handleCloseClick);
            // Add new listener
            closeButton.addEventListener('click', this.handleCloseClick.bind(this));
        }
    }

    // Handle close button click
    handleCloseClick(event) {
        event.preventDefault();
        event.stopPropagation();
        console.log('Direct close button clicked'); // Debug log
        this.close();
    }

    // Force close the cart drawer
    forceClose() {
        this.classList.add('translate-x-full');
        this.style.pointerEvents = 'none';
        if (document.getElementById('CartDrawer-Overlay')) {
            document.getElementById('CartDrawer-Overlay').classList.add('opacity-0', 'invisible');
        }
        document.body.classList.remove('!overflow-hidden');
    }

    // Cleanup when element is disconnected
    disconnectedCallback() {
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
        }
    }
}

customElements.define('cart-drawer', CartDrawer);

// Ensure cart drawer is closed on page load
document.addEventListener('DOMContentLoaded', function() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
        cartDrawer.forceClose();
    }
});

// Also ensure it's closed when the window loads
window.addEventListener('load', function() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
        cartDrawer.forceClose();
    }
});

class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [
            {
                id: 'CartDrawer',
                section: 'cart-drawer',
                selector: '.drawer__inner'
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section'
            },
            {
                id: 'cart-price',
                section: 'cart-price',
                selector: '.shopify-section'
            },
        ];
    }
}

customElements.define('cart-drawer-items', CartDrawerItems);